























import { Component, Prop, Vue } from 'vue-property-decorator';
import { signIn, signOut } from '@/utils/login';
import { User } from '@/models/user';

@Component
export default class NotLoggedPanel extends Vue {

    @Prop() private user!: User;

    login() {
        signIn();
    }

    logout() {
        signOut();
    }

}
